module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mod"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('img', {
    staticClass: "largeIcon",
    attrs: {
      "src": "/static/img/对勾.svg",
      "data-src": "/static/img/对勾.svg",
      "alt": "largeIcon"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "info"
  }, [_vm._v("\n    合同签署成功\n  ")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "submain"
  }, [_c('span', {
    staticClass: "tag",
    on: {
      "click": _vm.returnCart
    }
  }, [_vm._v("\n      返回首页\n    ")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "summary"
  }, [_vm._v("\n   您已完成实名认证，"), _c('span', {
    staticStyle: {
      "color": "#67C08C"
    }
  }, [_vm._v("获2张病毒折扣券")]), _vm._v("，快去下单使用吧\n  ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2f5e45ea","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Authentication/AuthenticationSuccess.vue
// module id = 1586
// module chunks = 8